import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentType: 'PRODUCT',
};

const aiSmartContentTypeSlice = createSlice({
  name: 'adminClientAISmartContentType',
  initialState,
  reducers: {
    setAISmartContentType: (state, action) => {
      state.currentType = action.payload || 'PRODUCT';
    },
  },
});

export const { setAISmartContentType } = aiSmartContentTypeSlice.actions;

export const aiSmartContentTypeSelector = (state) =>
  state.adminClientAISmartContentType?.currentType || 'PRODUCT';

export default aiSmartContentTypeSlice.reducer;

